module.exports = __webpack_public_path__ + "img/231.meeting_room.574ee797.svg";